var map = {
	"./arrow-short-bottom.svg": 2483,
	"./caret-down.svg": 811,
	"./check.svg": 1995,
	"./chevron.svg": 2302,
	"./facebook.svg": 6921,
	"./instagram.svg": 3083,
	"./linkedin.svg": 8839,
	"./min-circle.svg": 6384,
	"./plus-circle.svg": 8462,
	"./question-circle.svg": 902,
	"./quote.svg": 5331,
	"./search.svg": 7133,
	"./twitter.svg": 6278,
	"./webatvantage.svg": 6188,
	"./x.svg": 6959,
	"./youtube.svg": 4140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;